import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer-section" className="py-20 px-4 bg-[#FFF0E6]" data-id="element-90">
      <div className="max-w-3xl mx-auto text-center" data-id="element-91">
        <FadeIn data-id="element-92">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border-2 border-[#E8604C]/20 relative overflow-hidden" data-id="element-93">
            {/* Decorative background element */}
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-[#F5A623]/10 rounded-full blur-3xl" data-id="element-94"></div>
            <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-[#E8604C]/10 rounded-full blur-3xl" data-id="element-95"></div>

            <div className="relative z-10" data-id="element-96">
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2D2A26] mb-4" data-id="element-97">
                Recupera el respeto y la calma en tu casa
              </h2>
              <p className="font-sans text-xl text-[#2D2A26]/80 mb-8" data-id="element-98">
                por menos de lo que cuesta un café.
              </p>

              <div className="mb-8" data-id="element-99">
                <p className="text-sm text-[#2D2A26]/60 uppercase tracking-wider font-bold mb-2" data-id="element-100">
                  Precio Hoy
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-101">
                  <span className="text-6xl font-serif font-bold text-[#E8604C]" data-id="element-102">
                    $6.36
                  </span>
                  <span className="text-xl text-[#2D2A26]/60 font-medium mt-4" data-id="element-103">
                    USD
                  </span>
                </div>
              </div>

              <p className="font-sans text-[#2D2A26]/70 mb-8 max-w-md mx-auto" data-id="element-104">
                Acceso inmediato a la guía completa que transformará tus tardes.
              </p>

              <Button className="w-full md:w-auto text-xl py-5 px-10 shadow-xl mb-4" data-id="element-105">
                Quiero que me escuche: Descargar el Plan
              </Button>

              <div className="flex items-center justify-center gap-2 text-sm text-[#2D2A26]/60 mt-4" data-id="element-106">
                <Lock className="w-4 h-4" data-id="element-107" />
                <span data-id="element-108">Pago seguro y entrega instantánea en tu correo.</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}